import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from 'shared/shared.module';
import { EcommerceRoutingModule } from './ecommerce-routing.module';
import { ProductPanelModule } from '../product-panel/product-panel.module';

import { EcommerceComponent } from './ecommerce.component';
import { MarqueeComponent } from './components/marquee/marquee.component';
import { BaseSegmentComponent } from './components/base/_base-segment.component';
import { OverviewComponent } from './components/overview/overview.component';
import { SpecificationsComponent } from './components/specifications/specifications.component';
import { FitmentComponent } from './components/fitment/fitment.component';
import { DigitalAssetComponent } from './components/digital-asset/digital-asset.component';
import { ShippingComponent } from './components/shipping/shipping.component';
import { AboutComponent } from './components/about/about.component';


@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        SharedModule,
        EcommerceRoutingModule,
        ProductPanelModule,
    ],
    declarations: [
        EcommerceComponent,
        MarqueeComponent,
        OverviewComponent,
        SpecificationsComponent,
        FitmentComponent,
        DigitalAssetComponent,
        ShippingComponent,
        AboutComponent,
        BaseSegmentComponent,
    ],
    exports: [
        EcommerceComponent,
        MarqueeComponent,
        OverviewComponent,
        SpecificationsComponent,
        FitmentComponent,
        DigitalAssetComponent,
        ShippingComponent,
        AboutComponent,
    ]
})
export class EcommerceModule {}
